var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-section"},_vm._l((_vm.data),function(item,index){return _c('a',{key:index,staticClass:"item",class:_vm.isActive(item.href, index),attrs:{"href":`#${item.href}`}},[_vm._v("\n        "+_vm._s(item.title)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }